import React from 'react'
import { PropagateLoader } from "react-spinners";

const Spinner = () => {
  return (
    <div className='spinner flex'>
        <PropagateLoader color="white" className='spinner flex items-center justify-center py-2 text-white' />
    </div>
  )
}

export default Spinner